import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getSEOMetaInfo } from '../../utils/seo-utils';

const SEOHead = ({ pathname }) => {
  const metaInfo = getSEOMetaInfo(pathname);
  return (
    <Helmet>
      <title>{metaInfo.title}</title>
      <meta name="description" content={metaInfo.description} />
      {metaInfo.keywords && <meta name="keywords" content={metaInfo.keywords} />}
      <meta property="og:title" content={metaInfo.title} />
      <meta property="og:description" content={metaInfo.description} />
      <meta property="og:type" content="website" />
      {metaInfo.image && <meta name="image" content={metaInfo.image} />}
      {metaInfo.canonical && <link rel="canonical" href={metaInfo.canonical} />}
    </Helmet>
  );
};

export default SEOHead;
